import DialogBase from "../libs/DialogBase";
import Splide from '@splidejs/splide';
import Util from "../libs/Util";

export default class DialogRoomDetail extends DialogBase {
  constructor() {
    super("#dialog_roomdetail");

    this.CL_ACTIVE = 'isActive';

    this.splideMain = null;
    this.splideThumb = null;
  }

  addEvent(_target,_data){
    _target.querySelectorAll('.js-dialog_roomdetail').forEach(el=>{
      el.addEventListener('click',(e)=>{
        const target = e.currentTarget;
        this.onClickOpen(_data[target.dataset.roomcode]);
      });
    });
  }

  onClickOpen(_data){
    if(this.splideMain) {
      this.splideMain.destroy();
      this.splideThumb.destroy();
    }

    this.target.querySelector('.gl_common_dialog__head .-ttl span').innerText = _data.description;
    this.target.querySelector('.-js-room_name').innerText = _data.description;

    const images = Util.checkItems(_data.roomimages.roomimagelist.roomimage);
    let galleryHtml = '';
    images.forEach(img=>{
      galleryHtml += `<li class="splide__slide"><img src="${img.href}" loading="lazy" alt=""></li>`;
    });
    this.target.querySelectorAll('.-js-room_gallery .splide__list').forEach(el=>{el.innerHTML = galleryHtml;});

    let exBed = '';
    if(_data.plans.length > 0){
      if(_data.plans[0].rateinfos.rateinfo.included){
        switch (_data.plans[0].rateinfos.rateinfo.included){
          case "Extra Bed":
            exBed = LtikeCommon.HOTEL.TEXT.EX_BED;
            break;
        }
      }
    }

    let infoHtml = '';

    //部屋概要
    infoHtml += `
    <div>
      <dt>${_data.bed_type}${exBed}</dt>
      <dd>
        <ul>
          <li>部屋の広さ：${_data.size_of_room}㎡</li>
          <li>最大人数(大人${_data.max_occupancy_per_room}人、子供${_data.max_infant_in_room}人)</li>
        </ul>
      </dd>
    </div>
    `;

    //アメニティ
    const amenities = Util.checkItems(_data.roomamenities2.categorylist.categoryitem);
    amenities.forEach(amenity=>{
      const items = Util.checkItems(amenity.detaillist.detailitem);
      infoHtml += `
      <div>
        <dt>${amenity.title}</dt>
        <dd>
          <ul>
            ${items.map(item => `<li>${item.amenity}</li>`).join("")}
          </ul>
        </dd>
      </div>
      `;
    });
    this.target.querySelector('.-js-room_info').innerHTML = infoHtml;

    this.splideMain = new Splide(this.target.querySelector('.-slide__main .splide'),{
      width: '100%',
      height: '100%',
      rewind: true,
      pagination: false,
      arrows: true,
      flickPower: 100,
    });

    this.splideThumb = new Splide(this.target.querySelector('.-slide__sub .splide'),{
      //autoWidth: true,
      rewind: true,
      focus: images.length > 5 ? 'center' : 0,
      flickPower: 100,
      pagination: false,
      arrows: false,
      isNavigation: true,
      perPage:5,
      gap: 8,
      breakpoints:{
        [Util.BREAK_POINT]: {
          perPage:3,
          gap: 4,
          focus: images.length > 3 ? 'center' : 0,
        }
      }
    });

    const current = this.target.querySelector('.-slide__main .-count .-current');
    const total   = this.target.querySelector('.-slide__main .-count .-total');
    this.splideMain.on('mounted move',  ()=> {
      current.textContent = this.splideMain.index + 1;
      total.textContent   = this.splideMain.length;
    });

    this.splideMain.sync(this.splideThumb);
    this.splideMain.mount();
    this.splideThumb.mount();

    this.onOpen();
  }

  onOpenBefore() {
    super.onOpenBefore();
    this.target.querySelector('.dialog_roomdetail__sub').scrollTop = 0;
  }
}
